import { MenuItem as MUIMenuItem, type MenuItemProps as MUIMenuItemProps } from '@mui/material'
import { forwardRef } from 'react'
import type { LinkProps } from 'react-router-dom'
import { Link } from '@/helpers/Link'

//	///////////////////////
//	MARK: TYPES
export type TMenuItemLinkProps = MUIMenuItemProps & LinkProps

//	///////////////////////
//	MARK: EXPORTS
export const MenuItemLink = forwardRef<HTMLAnchorElement, TMenuItemLinkProps>((props, ref) => (
  <MUIMenuItem component={Link} ref={ref} {...props} />
))
